import { useAuth } from "../auth/useAuth";
import { Language, useI18n } from "../i18n";

type TopBarProps = {
  title: string;
};

export function TopBar({ title }: TopBarProps) {
  const { user, signIn, signOut } = useAuth();
  const { currentLanguage, setLanguage, supportedLanguages, t } = useI18n();

  return (
    <header className="topbar">
      <div>
        <h1>{title}</h1>
        <p className="muted">{t("app.subtitle")}</p>
      </div>
      <div className="topbar-actions">
        <label className="language-switcher">
          <span>{t("language.label")}</span>
          <select value={currentLanguage} onChange={(event) => setLanguage(event.target.value as Language)}>
            {supportedLanguages.map((language) => (
              <option key={language} value={language}>
                {t(`language.${language}`)}
              </option>
            ))}
          </select>
        </label>
        <button type="button" onClick={() => (user ? signOut() : signIn())}>
          {user ? t("common.signOut") : t("common.signIn")}
        </button>
      </div>
    </header>
  );
}
